// utils/mvText.ts
//
// Marriage Verdict screens are authored in English, with option values that
// are sent to the backend as-is. `tx` translates only what the user *sees*:
// it looks the English text up under "mv.<slug>" in the locale files and falls
// back to the English text itself. Screens call useTranslation() (or
// useMvLanguage) so they re-render when the preferred language changes.
import i18n from "../i18n";
import { useTranslation } from "react-i18next";

export const mvSlug = (s: string): string =>
  s
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "_")
    .replace(/^_+|_+$/g, "")
    .slice(0, 60);

export const tx = (s: string): string =>
  s ? i18n.t(`mv.${mvSlug(s)}`, { defaultValue: s }) : s;

/** Subscribes the calling component to language changes. */
export const useMvLanguage = (): string => useTranslation().i18n.language;
